import { SuccessResponseModel } from '@models/common';
import * as Sentry from '@sentry/nextjs';
import { useState } from 'react';
import { useImprvApi } from './useImprvApi';

export const useLikesService = () => {
  const imprvApi = useImprvApi();
  const [isPendingLike, setIsPendingLike] = useState(false);
  const [isPendingUnlike, setIsPendingUnlike] = useState(false);

  const likeGoal = async (goalEntityId: string): Promise<SuccessResponseModel> => {
    try {
      setIsPendingLike(true);
      const result = await imprvApi.likeGoal(goalEntityId);
      return result;
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    } finally {
      setIsPendingLike(false);
    }
  };

  const unlikeGoal = async (goalEntityId: string): Promise<SuccessResponseModel> => {
    try {
      setIsPendingUnlike(true);
      const result = await imprvApi.unlikeGoal(goalEntityId);
      return result;
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    } finally {
      setIsPendingUnlike(false);
    }
  };

  return {
    likeGoal,
    unlikeGoal,
    isPendingLike,
    isPendingUnlike
  };
};
